import { useNavigate } from "react-router-dom";

export const useTrainings = () => {
  const navigate = useNavigate();
  return { navigate };
};
